import React, { useState } from 'react';
import { Button } from '@chakra-ui/react';
import TextField from '@material-ui/core/TextField';
import AdminState from '../AdminState';
import './SliderForm.css';

export default function SliderForm({ fields, onSubmit, deleteForm = false, actionLabel = 'Save' }) {
  const [submission, setSubmission] = useState(() => Object.fromEntries(fields.map(field => [field.key, field.defaultValue ?? ''])));
  const [errors, setErrors] = useState({});
  const [pending, setPending] = useState(false);
  const [saveError, setSaveError] = useState('');
  const validation = (field, value) => {
    if (!String(value).trim()) return `${field.placeholder.split(' (')[0]} is required.`;
    return field.validate && !String(value).match(field.validate) ? field.errorText : '';
  };
  const submit = async event => {
    event.preventDefault();
    if (pending) return;
    const nextErrors = Object.fromEntries(fields.map(field => [field.key, validation(field, submission[field.key])]));
    setErrors(nextErrors);
    const invalid = fields.find(field => nextErrors[field.key]);
    if (invalid) {
      event.currentTarget.elements.namedItem(invalid.key)?.focus();
      return;
    }
    setSaveError('');
    setPending(true);
    try { await onSubmit(submission); }
    catch (error) { setSaveError(error.message || 'Could not save these changes. Try again.'); }
    finally { setPending(false); }
  };
  return <form className="SliderForm" onSubmit={submit} noValidate>
    {saveError && <AdminState status="error" title="Changes could not be saved" description={saveError} mb={0} />}
    {fields.map(field => <TextField fullWidth required key={field.key} id={field.key} name={field.key}
      label={field.placeholder} helperText={errors[field.key]} error={Boolean(errors[field.key])}
      value={submission[field.key]} disabled={field.disabled || pending}
      onChange={event => {
        const value = event.target.value;
        setSubmission(current => ({ ...current, [field.key]: value }));
        setErrors(current => ({ ...current, [field.key]: validation(field, value) }));
      }} />)}
    <div className="admin-form-actions admin-form-actions-end">
      <Button type="submit" variant="solid" colorScheme={deleteForm ? 'red' : 'blue'}
        isLoading={pending} aria-label={pending ? (deleteForm ? 'Deleting…' : 'Saving…') : undefined}>
        {deleteForm ? 'Delete' : actionLabel}
      </Button>
    </div>
  </form>;
}
